"use strict";

module.exports = function (element, modal) {
    if (!modal) {
        var position = element && element.length ? element.offset().top : 0;
        $("html, body").animate({
            scrollTop: position
        }, 500);
        if (!element) {
            $(".logo-home").focus();
        }
    } else if (modal.length && element && element.length) {
        // element's position in the modal
        // additional 200px added to scroll to the end of the element
        // to make sure the whole element is visible in the modal viewport
        var scrollOffset = element.position().top + modal.scrollTop() + 200; 
        modal.animate({
            scrollTop: scrollOffset
        }, 500);
    }
};
